import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Host } from '../../../features/hosts/api/types/host';
import { Scrollbar } from '../../atoms/scrollbar';
import AvatarWithInfo from '../../molecules/avatar-with-info';

import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';

interface Props {
  hosts: Host[];
  error: string;
  isLoading: boolean;
}

export const HostsTableSimple = ({ hosts, error, isLoading }: Props) => {
  const { t } = useTranslation(['hosts']);

  const columns = [
    {
      id: 'name',
      label: t('hosts:table.name'),
    },
    {
      id: 'billingGroup',
      label: t('hosts:table.billingGroup'),
    },
    {
      id: 'destinationGroup',
      label: t('hosts:table.destinationGroup'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <Scrollbar>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {hosts?.map(host => (
              <TableRow hover key={host.id}>
                <TableCell>
                  <AvatarWithInfo
                    avatarText={`${host.firstName.slice(0, 1)} ${host.lastName.slice(0, 1)}`}
                    primaryText={`${host.firstName} ${host.lastName}`}
                    secondaryText={host.email}
                    src=""
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="primary.main">
                    {host.billingGroup ? host.billingGroup.name : t('hosts:table.setBillingGroup')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="primary.main">
                    {host.destinationGroup
                      ? host.destinationGroup.name
                      : t('hosts:table.setDestinationGroup')}{' '}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
      <DataStatusIndicator dataLength={hosts?.length} error={error} isFetching={isLoading} />
    </Box>
  );
};
